import { render, staticRenderFns } from "./base-dropdown-item.vue?vue&type=template&id=7d6f8bea&"
import script from "./base-dropdown-item.vue?vue&type=script&lang=js&"
export * from "./base-dropdown-item.vue?vue&type=script&lang=js&"
import style0 from "./base-dropdown-item.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports